<script setup lang="ts">
const props = defineProps({
  color: {
    type: String,
    default: '#2c2f39',
    required: false,
  },
})
</script>

<template>
  <svg
    class="dropdown"
    width="11"
    height="7"
    viewBox="0 0 11 7"
    :fill="props.color"
  >
    <path
      :fill="props.color"
      d="M5.53351 3.90232L1.96902 0.337831C1.51858 -0.11261 0.788272 -0.11261 0.337831 0.337831C-0.11261 0.788272 -0.11261 1.51858 0.337831 1.96902L4.71778 6.34897C5.16817 6.79936 5.89837 6.79942 6.34884 6.34911L10.662 2.03733C11.1126 1.58696 11.1127 0.856651 10.6623 0.406136C10.2119 -0.0443798 9.48163 -0.0445 9.03111 0.405867L5.53351 3.90232Z"
    />
  </svg>
</template>
<style lang="scss" scoped>
.dropdown {
  width: 10px;
}
</style>
